/**
 * Roteiro da Ficha Técnica — ordem e instruções por processo.
 * Subcoleção: org/{orgId}/technical-sheet/{technicalSheetId}/route
 */
export const TECHNICAL_SHEET_ROUTE = 'TechnicalSheetRoute';
//# sourceMappingURL=technical-sheet-route.js.map